import { IS_LIVE_TRANSCRIPTS_ENABLED } from '@/features/flags/legacy-flags';
import { TabType, useSessionWindows } from '@/hooks/query/useQuerySessionWindows';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { useCurrentSessionId } from '@heidi/runtime/shell';
import { useCallback } from 'react';
import { isTablet } from 'react-device-detect';

export const useSplitScreen = () => {
  const sessionId = useCurrentSessionId();
  const { sessionWindows, handlePinLeft } = useSessionWindows({
    sessionId,
  });
  const { data: user } = useQueryUser();

  const isMobile = useIsMobile();

  const splitScreen = useCallback(
    // `isTranscriptTabPending`: the Transcript tab is about to appear because
    // recording is starting, so pin it without waiting to find it in a window.
    ({ isTranscriptTabPending = false }: { isTranscriptTabPending?: boolean } = {}) => {
      // if (activeTab?.name !== TabType.TRANSCRIPT) {
      if (sessionWindows && sessionWindows?.length > 1) {
        return;
      }
      if (!IS_LIVE_TRANSCRIPTS_ENABLED()) {
        return;
      }
      if (
        user &&
        user.session_settings &&
        !user.session_settings.is_live_transcription_split_view
      ) {
        return;
      }
      if (
        isTranscriptTabPending ||
        sessionWindows?.flatMap((w) => w.tabs).some((t) => t.name === TabType.TRANSCRIPT)
      ) {
        if (!isTablet && !isMobile) {
          handlePinLeft({
            name: TabType.TRANSCRIPT,
          });
        }
      }
    },
    [user, handlePinLeft, isMobile, sessionWindows]
  );

  return { splitScreen };
};
